<!--
 * @Description: 
 * @Author: weig
 * @Date: 2022-01-04 16:01:49
 * @LastEditors: weig
 * @LastEditTime: 2022-02-11 16:43:18
-->
<template>
    <div>
        <div class="crop-demo">
            <ul class="upload-photo">
                <!-- 最多上传一张图片 -->
                <li @mouseover="mouseoverImg()" @mouseout="mouseoutImg()">
                    <img ref="img1" src="../../assets/img/avatar.png" style="object-fit:cover;" @click="uploadPhoto"/>
                    <div ref="deleteImg1" class="delete-img">
                        <el-icon style="margin: auto;line-height:40px;" @click="deleteImage"><Delete/></el-icon>
                    </div>
                </li>
            </ul>
            <input type="file" hidden ref="photoFile" @change="fileChange" style="display: none;"/>
        </div>

        <el-dialog title="裁剪图片" v-model="dialogVisible" width="600px" :z-index="zindex">
            <!-- 1.截图区域 -->
            <vue-cropper
                ref="cropper"
                :src="imgSrc"
                :ready="cropImage"
                :zoom="cropImage"
                :cropmove="cropImage"
                :aspectRatio="aspectRatio"
                style="width:100%;height:300px;"
                :autoCrop="autoCrop"
                :wheelZoomRatio="wheelZoomRatio"
            ></vue-cropper>
            <!-- 2.操作按钮区域 -->
            <div class="btn-content">
                <input class="btn" type="button" value="↺" title="左旋转" @click="rotateLeft" />
                <input class="btn" type="button" value="↻" title="右旋转" @click="rotateRight" />
                <input class="btn" type="button" value="↓" title="下载" @click="down('blob')" />
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelCrop">取 消</el-button>
                    <el-button type="primary" @click="submitPhoto">确 定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
/**
 * 图片上传组件
 * 使用说明
  import EupCropper from '@/components/eup-uploadPhoto/eup-cropper.vue'
  components: { EupCropper:EupCropper }
  <eup-cropper @resUploadData="resUploadData" @defaultSrc="deleteImg" :src="state.form.portraitUrl" :aspectRatio="1" :readonly="true"></eup-cropper>
*/
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { reactive, toRefs, onBeforeMount, onMounted, ref, watch } from 'vue'
import {elConfirmDialog, IsNullOrEmpty, base64ToFile} from '@/common/js/comm'
import { ElMessageBox, ElMessage } from 'element-plus';
import lrz from 'lrz'
import { postimg } from "@/serviceApi/Image/Image";
export default {
  name: 'upload',
  components: {
    VueCropper
  },
  props:{
      //图片地址
      src: {
          Type: String,
          default: ""
      },
      //设置剪裁容器的比例（宽/高）
      aspectRatio:{
          Type: Number,
          default: 1
      },
      //自动裁剪
      autoCrop: {
          Type: Boolean,
          default: true
      },
      //滚轮放大/缩小
      wheelZoomRatio:{
          Type: Boolean,
          default: true
      },
      //是否禁用文件上传功能
      readonly:{
          Type: Boolean,
          default: false
      },
      //文件类型(枚举名或者值都可以)
      fileType:{
          Type: String,
          default: "Avatar"
      },
      //层级z-index
      zindex:{
          Type: Number,
          default: 9999
      }
  },
  setup(props, context) {
    const cropper = ref(null);
    const img1 = ref(null);
    const deleteImg1 = ref(null);
    const photoFile = ref(null);
    const data = reactive({
        defaultSrc: 'data:image/png;base64,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',//require("../assets/img/img.jpg"),
        imgSrc: "",
        cropImg: "",
        dialogVisible: false,

        uploadImage: "",//默认静态图片
        downImg: "#",
        fileInfo: null,
        previewSrcList: []
    });
    /**
     * @description 监听图片地址变化
     * @author weig
     */
    watch(() => props.src,(val) => {
        if (!IsNullOrEmpty(val)){
            img1.value.src = val;
        } else {
            img1.value.src = data.defaultSrc;
        }
    });
    onBeforeMount(() => {
    });
    onMounted(() => {
      data.uploadImage = img1.value;
      if (!IsNullOrEmpty(props.src) && props.readonly == false){
          img1.value.src = props.src;
        //   data.previewSrcList.push(img1.value.src);
          deleteImg1.value.style.display = "block";
      } else if (!IsNullOrEmpty(props.src) && props.readonly == true){
          img1.value.src = props.src;
        //   data.previewSrcList.push(img1.value.src);
          deleteImg1.value.style.display = "none";
      } else {
        deleteImg1.value.style.display = "none";
      }
    });
    /**
     * @description 开始剪切图片
     * @author weig
     */
    const cropImage = ()=>{
        cropper.value.getCroppedCanvas().toBlob(function (blob) {   
            let croppedImage = new File([blob],data.fileInfo.name,{type:blob.type},{ lastModified: Date.now()});
            data.fileInfo = croppedImage;
        });
        data.cropImg = cropper.value.getCroppedCanvas().toDataURL();
    }
    /**
     * @description 取消截图
     * @author weig
     */
    const cancelCrop = ()=>{
        data.dialogVisible = false;
        data.cropImg = data.defaultSrc;
    }
    /**
     * @description 删除图片
     * @author weig
     */
    const deleteImage = ()=>{
        if (props.readonly == true){
            return;
        }
        elConfirmDialog(ElMessageBox, "是否删除该照片?","删除图片", "warning", 
            function(){
                img1.value.src = data.defaultSrc;
                // data.previewSrcList.push(img1.value.src);
                context.emit("defaultSrc", "");
                ElMessage.success("删除成功！");
            },
            function(){
                ElMessage.info("已取消删除");
            }
        );
    }
    /**
     * @description 鼠标移入图像
     * @author weig
     */
    const mouseoverImg = ()=>{
        if(props.readonly == true){
            return;
        }
        displayControl(img1.value, deleteImg1.value);
    }
    /**
     * @description
     * @author weig
     * @param {Object} img
     * @param {Object} deleteImg
     */
    const displayControl =(img, deleteImg)=>{
        if (img.src == data.uploadImage) {
            deleteImg.style.display = "none";
        } else {
            deleteImg.style.display = "block";
        }
    }
    /**
     * @description 鼠标移出图像--删除图标隐藏
     * @author weig
     */
    const mouseoutImg = ()=>{
        if(props.readonly == true){
            return;
        }
        deleteImg1.value.style.display = "none";
    }
    /**
     * @description 本地上传图片
     * @author weig
     */
    const uploadPhoto = () =>{
        if (props.readonly != true) {
            photoFile.value.click();
            restore();
        } else {
            var imgs = document.getElementsByTagName("img");
            imgs[0].focus();
            for(var i = 0;i<imgs.length;i++){
                imgs[i].onclick = expandPhoto;
                imgs[i].onkeydown = expandPhoto;
            }
        }
    }
    /**
     * @description 点击图片展开放大
     * @author weig
     */
    function expandPhoto(){
        var that = this;
        var overlay = document.createElement("div");
        overlay.setAttribute("id","overlay");
        overlay.setAttribute("class","overlay");
        document.body.appendChild(overlay);

        var img = document.createElement("img");
        img.setAttribute("id","expand")
        img.setAttribute("class","overlayimg");
        img.src = that.getAttribute("src");
        document.getElementById("overlay").appendChild(img);
        /* img.onclick = restore; */
    }

    function restore(){
        /* document.body.removeChild(document.getElementById("overlay")); */
   /*      document.body.removeChild(document.getElementById("expand")); */
    }
    /**
     * @description 选择文件
     * @author weig
     * @param {Object}
     */
    const fileChange = (e)=>{
        let file = photoFile.value.files[0];
        data.fileInfo = file;
        if (/.(png|jpg|jpeg)$/.test(file.name)) {
            let fr = new FileReader();
            fr.readAsDataURL(file);
            fr.onload = e => {
                data.dialogVisible = true;
                data.imgSrc = e.target.result;
                cropper.value && cropper.value.replace(e.target.result);
                photoFile.value.value = "";
            };
        } else {
            ElMessage.warning("请选择符合格式要求的图片(png|jpg|jpeg)");
            photoFile.value.value = "";
            data.fileInfo = null;
        }
    }
    /**
     * @description 上传图像
     * @author weig
     */
    const submitPhoto = ()=>{
        var file = data.fileInfo;
        if (IsNullOrEmpty(file)){
            ElMessage.error("图片不能为空！");
            return;
        }
        if(file.size > 10000000){
            ElMessage.error("图片超出大小,请压缩后再上传");
            return;
            }
        var formData = new FormData();
        if (file.size > 5000000){
            lrz(file, {
                fileName: file.name,
                quality: 0.5 //设置压缩质量
            }).then((res)=>{
                let tepm_file = new window.File([res.file], file.name,{type:file.type});
                formData.append("File", tepm_file);
                formData.append("FileCategory", props.fileType);
                postimg(formData).then(function(res) {
                    if (1 == res.code) {
                        img1.value.src = res.data.url;
                        data.dialogVisible = false;
                        context.emit("resUploadData", {data: res.data});
                    } else {
                        ElMessage.error(res.msg);
                    }
                });
            });
        } else {
            formData.append("File", file);
            formData.append("FileCategory", props.fileType);
            postimg(formData).then(function(res) {
                if (1 == res.code) {
                    img1.value.src = res.data.url;
                    data.dialogVisible = false;
                    context.emit("resUploadData", {data: res.data});
                } else {
                    ElMessage.error(res.msg);
                }
            });
        }
    }
    /**
     * @description 放大
     * @author weig
     * @param {Number} num
     */
    const zoomOut = (num)=>{
        cropper.value.zoom(0.1);
    }
    /**
     * @description 缩小
     * @author weig
     * @param {Number} num
     */
    const zoomIn = (num) =>{
        cropper.value.zoom(-0.1);
    }
    /**
     * @description 左旋转
     * @author weig
     */
    const rotateLeft = ()=>{
        cropper.value.rotate(-45);
    }
    /**
     * @description 右旋转
     * @author weig
     */
    const rotateRight = ()=>{
        cropper.value.rotate(45);
    }
    /**
     * @description 下载
     * @author weig
     * @param {String} type
     */
    const down = (type)=>{
        var aLink = document.createElement("a");
        aLink.download = "author-img";
        var that = data;
        if (type === "blob") {
            cropper.value.getCroppedCanvas().toBlob(data => {
                that.downImg = window.URL.createObjectURL(data);
                aLink.href = window.URL.createObjectURL(data);
                aLink.click();
            });
        } else {
            cropper.value.getCropData(data => {
                that.downImg = data;
                aLink.href = data;
                aLink.click();
            });
        }
    }
    return {
      ...toRefs(data),
      cropImage,
      cancelCrop,
      deleteImage,
      mouseoverImg,
      uploadPhoto,
      mouseoutImg,
      fileChange,
      submitPhoto,
      zoomOut,
      zoomIn,
      rotateLeft,
      rotateRight,
      down,
      cropper,
      img1,
      deleteImg1,
      photoFile
    }
  },
}

</script>
<style lang="less">
    .upload-photo{
        li {
          width: 146px;
          height: 146px;
          margin-right: 15px;
          position: relative;
          .delete-img {
            position: absolute;
            width: 146px;
            height: 40px;
            line-height: 40px;
            left: 0px;
            top: 106px;
            background: rgba(59, 60, 61, 0.5);
            // box-sizing: content-box;
            z-index: 999;
            cursor: pointer;
            text-align: right;
            i {
              margin: 8px 10px 0 0;
              display: block;
              font-size: 24px;
              color: white;
            }
          }
        }
        img {
          border: 1px dashed #d9d9d9;
          border-radius: 5px;
          box-sizing: border-box;
          width: 146px;
          height: 146px;
          margin-top: 0px;
          &:hover {
            border: 1px dashed #409eff;
          }
        }
    }
          // 2.操作按钮区域
      .btn-content {
        width: 350px;
        margin: 10px 20px;
        text-align: center;
        margin: 10px auto;
        // #uploads {
        //   position: absolute;
        //   clip: rect(0 0 0 0);
        // }
        .btn {
          height: 32px;
          width: 32px;
          font-size: 20px;
          margin: 3px 5px;
          background-color: #fff;
          border: 1px solid #999;
          border-radius: 4px;
          cursor: pointer;
        }
      }
</style>